import { Component, Input } from '@angular/core';
import { CdnStatus } from '@shared/models/site';
import { SiteStatusComponent } from '../site-status/site-status.component';
import { SitePassthroughModeLabelComponent } from '../label/site-passthrough-mode-label/site-passthrough-mode-label.component';
import { ActivationCdnLabelComponent } from '../label/activation-cdn-label/activation-cdn-label.component';
import { AuditModeLabelComponent } from '../label/audit-mode-label/audit-mode-label.component';
import { CertificateErrorLabelComponent } from '../label/certificate-error-label/certificate-error-label.component';

@Component({
  template: `
    <span class="mx-2"><app-site-status [status]="site.status" /></span>
    @if (site.passthroughMode) {
      <app-site-passthrough-mode-label />
    }
    @if (site.cdn) {
      <app-activation-cdn-label [cdnStatus]="site.cdnStatus" />
    }
    @if (site.auditMode) {
      <app-audit-mode-label />
    }
    @if (site.isACertificateInError) {
      <app-certificate-error-label />
    }
  `,
  selector: 'app-site-status-full',
  imports: [
    SiteStatusComponent,
    SitePassthroughModeLabelComponent,
    ActivationCdnLabelComponent,
    AuditModeLabelComponent,
    CertificateErrorLabelComponent,
  ],
  styles: `
    :host {
      display: flex;
      align-items: center;
    }
  `,
})
export class SiteStatusFullComponent {
  @Input() site: Site;
}

type Site = {
  status: string;
  passthroughMode: boolean;
  cdn: string;
  cdnStatus: CdnStatus;
  auditMode: boolean;
  isACertificateInError: boolean;
};
